import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { IViewContainerTheme } from "interfaces/viewContainerTheme";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const commonCss = (theme: IViewContainerTheme) => css`
  font-size: 16px;
  cursor: pointer;
  height: 100%;
  color: ${theme.primaryColor};
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 17px;

  &:hover {
    text-decoration: none;
  }

  .name {
    display: inline-block;
    font-size: 14px;
    margin-left: 9px;
  }
`;

interface IStyledSpan {
  hasChildren: boolean;
}

export const StyledSpan = styled.span<IStyledSpan>`
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => commonCss(props.theme)
  }
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      !props.hasChildren &&
      `
margin-left: 0;
padding: 0 17px;
`
  };
`;
